// extracted by mini-css-extract-plugin
export default {"boardTabsWrapper":"TaskTabs_boardTabsWrapper__FfP+7","writeBtn":"TaskTabs_writeBtn__xm4KE"};